import {
  Box,
  Button,
  Container,
  Grid,
  Hidden,
  Typography,
} from '@material-ui/core';
import { InView } from 'react-intersection-observer';
import { graphql, useStaticQuery, navigate } from 'gatsby';
import { makeStyles } from '@material-ui/core/styles';
import { motion } from 'framer-motion';
import * as React from 'react';

import Background from '../styled/background';
import Markdown from '../styled/markdown';
import YTVideo from '../shared/yt-video';

const HISTORY_QUERY = graphql`
  query historyQuery {
    contentfulHistoria {
      resumen {
        resumen
      }
      videos
      background {
        fluid(quality: 90, maxWidth: 2000) {
          srcSetWebp
          srcWebp
        }
      }
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    height: 'calc(90vh)',
  },
  buttonContainer: {
    width: '100%',
  },
  resumeContainer: {
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(32),
    },
  },
  textWhite: {
    color: 'white',
  },
}));

const History = () => {
  const {
    contentfulHistoria: { resumen, background, videos },
  } = useStaticQuery(HISTORY_QUERY);
  const classes = useStyles();

  const variants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  return (
    <Background height="calc(105vh)" image={background.fluid.srcWebp}>
      <Container maxWidth="lg">
        <Grid
          alignItems="flex-end"
          container
          spacing={3}
          className={classes.gridContainer}
        >
          <Grid item xs={12} lg={4}>
            <InView threshold={0.5}>
              {({ inView, ref }) => (
                <motion.div
                  animate={inView ? 'visible' : 'hidden'}
                  ref={ref}
                  variants={variants}
                  transition={{ duration: 0.7, ease: 'easeOut' }}
                  className={classes.resumeContainer}
                >
                  <Markdown className="gray" color="white">
                    {resumen.resumen}
                  </Markdown>
                </motion.div>
              )}
            </InView>

            <Box
              mt={3}
              display="flex"
              justifyContent="flex-end"
              className={classes.buttonContainer}
            >
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate('/history')}
                color="primary"
              >
                Leer más...
              </Button>
            </Box>
            <Typography className={classes.textWhite} variant="subtitle1">
              &copy; Mario Cruz Cervantes
            </Typography>
          </Grid>
          <Grid item xs={12} lg={1} />
          <InView threshold={0.5}>
            {({ inView, ref }) => (
              <Grid
                container
                item
                xs={12}
                lg={7}
                spacing={3}
                component={motion.div}
                animate={inView ? 'visible' : 'hidden'}
                ref={ref}
                variants={variants}
                transition={{ duration: 0.7, ease: 'easeOut' }}
              >
                {videos.map((url, index) => (
                  <>
                    {index === 0 ? (
                      <Hidden smDown>
                        <Grid key={url} item xs={12} lg={6}>
                          <Box pb={4}>
                            <YTVideo url={url} size={160} />
                          </Box>
                        </Grid>
                      </Hidden>
                    ) : (
                      <Grid key={url} item xs={12} lg={6}>
                        <Box pb={4}>
                          <YTVideo url={url} size={160} />
                        </Box>
                      </Grid>
                    )}
                  </>
                ))}
              </Grid>
            )}
          </InView>
        </Grid>
      </Container>
    </Background>
  );
};

export default History;
